export const instance = {
  load: (path: string): string => {
    return require('@/assets' + (path.startsWith('/') ? '' : '/') + path)
  }
}

export default instance
